import React, {Suspense} from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import Loader from "../shared/components/loader";
import Navbar from "../components/navbar";
import ConfirmationDialog from "../shared/components/confirmation-dialog";
import ViewVersion from "../shared/components/view-version";
import {services as versionServices} from "../utils/Utils";
import Home from "../components/homePage/home";
import Accounts from "../components/accountsPage/accounts";
import Corporates from "../components/corporatesPage/corporates";
import Privileges from "../components/privilagePage/privileges";
import Roles from "../components/rolesPage/roles";
import UserHistory from "../components/homePage/userHistory";
import UserView from "../components/homePage/userView";

const MainLayout = () => {
  return (
    <div className={"h-100pe bg-gray"}>
      <Suspense fallback={<Loader load={true}/>}>
        <Navbar/>
        <ConfirmationDialog/>
        <ViewVersion services={versionServices}/>
      </Suspense>
      <div className={"list-view print-visible xindicate-full-list-view"}>
        {/* <ToggleButton /> */}
        <Suspense fallback={<Loader load={true}/>}>
          <Routes>
            <Route path="/home" element={<Home/>}/>
            <Route path="/roles" element={<Roles/>}/>
            <Route path="/accounts" element={<Accounts/>}/>
            <Route path="/corporates" element={<Corporates/>}/>
            <Route path="/privileges" element={<Privileges/>}/>
            <Route path="/user-actions/:id" element={<UserHistory/>} />
            <Route path="/user-view/:id" element={<UserView/>}/>
            <Route path="*" element={<Navigate to="/home"/>}/>
          </Routes>
        </Suspense>
      </div>
    </div>
  );
};

export default MainLayout;
